import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pothole-report-form',
  templateUrl: './pothole-report-form.component.html',
  styleUrls: ['./pothole-report-form.component.scss']
})
export class PotholeReportFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
